import { styled } from '../../../theme';
import { FacebookButton } from '../../FacebookButton';

export const FacebookConnectButton = styled(FacebookButton).attrs(() => ({
	text: 'Anslut med Facebook',
}))`
	width: 100%;
`;
